export const cart = {
  cartItems: {
    header: {
      article: 'Artikel',
      quantity: 'Menge:',
      price: 'Preis',
    },
    id: 'ID',
    description: 'Description',
    item: 'Item',
    itemPrice: 'Item price',
    quantity: 'Menge:',
    quantityTitle: 'The quantity represents the total number of this item in your cart.',
    total: 'Total',
    cartTotal: 'Warenkorb ({{count}})',
    cartTotal_plural: 'Warenkorb ({{count}})',
    selection: 'Auswahl',
    showSelection: 'Details einblenden',
    hideSelection: 'Details ausblenden',
    articleNr: 'Artikelnummer:',
    soldOut: 'Bald wieder verfügbar',
    notifyMe: 'Benachrichtigen Sie mich',
    message: {
      itemAddedToCart: 'Dein Artikel wurde zum Warenkorb hinzugefügt',
      itemCannotAddToCart: 'Artikel kann nicht in den Warenkorb gelegt werden',
      notEnoughInStock:
        'Leider sind von diesem Produkt derzeit nur noch {{ stock }} Stück verfügbar',
    },
    removeItem: 'Entfernen',
    addToWishlist: 'Auf die Merkliste',
    quantityShort: 'Menge',
    removeFromWishlist: 'Von Merkliste enfernen',
    cartTotalSingle: 'Warenkorb',
    unitPrice: 'Einzelpreis',
  },
  orderCost: {
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal after discounts:',
    shipping: 'Shipping:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'You saved:',
    salesTax: 'Sales Tax:',
    grossTax: 'The order total does not include tax of',
    grossIncludeTax: 'The order total includes tax of',
    total: 'Total:',
    toBeDetermined: 'TBD',
  },
  voucher: {
    coupon: 'Hast du einen Vorteilscode?',
    couponGiftcard: 'Haben Sie einen Gutschein oder Vorteilscode?',
    coupon_plural: 'Gutscheine oder Vorteilscodes',
    apply: 'Anwenden',
    placeholder: 'Promo code',
    applyVoucherSuccess: '{{voucherCode}} wurde hinterlegt.',
    applyGiftcardSuccess: 'Der Gutschein {{voucherCode}} wurde dem Warenkorb hinzugefügt.',
    removeVoucherSuccess: '{{voucherCode}} wurde entfernt.',
    anchorLabel: 'Gutschein/Vorteilscode eingeben oder entfernen.',
    vouchersApplied: 'Hinterlegte Gutscheine/Vorteilscodes',
    availableCoupons: 'Verfügbare Vorteilscodes',
    availableCouponsLabel: 'Du kannst diese Vorteilscodes hinzufügen.',
    promotionError: {
      ERR01: 'Die Aktion ist bereits beendet.',
      ERR02: 'Der Vorteilscode ist noch nicht gültig.',
      ERR03: 'Der Vorteilscode ist nicht gültig.',
      ERR05: 'Dein Warenkorb enthält kein Produkt, auf das die Aktion angewendet werden kann.',
      ERR06:
        'Der von dir angegebene Code wurde bereits eingelöst und kann nicht noch einmal verwendet werden.',
      ERR07: 'Der Mindestbestellwert für die Aktion ist nicht erreicht.',
      ERR08: 'Der Vorteilscode ist nicht gültig.',
      ERR09:
        'Aufgrund der Best-Preis-Logik können manche Aktionen nicht parallel eingelöst werden.',
      ERR10:
        'Der Versand ist kostenfrei, deshalb kann der von Dir angegebene Code kann nicht hinzugefügt werden.',
      ERR12: 'Der Gutschein wurde bereits eingelöst.',
      ERR13:
        'Leider können Vorteilscodes derzeit aus technischen Gründen nicht eingelöst werden. Bitte wenden Sie sich an unseren Kundenservice.',
      ERR14: 'Der Rabattcode kann auf deinen Warenkorb nicht angewendet werden.',
      ERR14WithDisclaimer:
        'Der Rabattcode kann auf deinen Warenkorb nicht angewendet werden. Bitte beachte die Aktionsbedingungen:<br>[Vorteilscode: {{voucherCode}}<br><br>{{disclaimer}}]',
    },
  },
  saveForLaterItems: {
    itemTotal: 'Saved for later ({{count}} item)',
    itemTotal_plural: 'Saved for later ({{count}} items)',
    cartTitle: 'Cart',
    saveForLater: 'Save For Later',
    moveToCart: 'Move To Cart',
    stock: 'Stock',
    forceInStock: 'In Stock',
  },
  slowRequestModal: {
    title: 'Die Gesamtsumme wird berechnet',
    message: 'Bitte haben Sie einen Moment Geduld.',
    thanks: 'Vielen Dank für Ihr Verständnis!',
    closeBtn: 'Berechnung abbrechen',
  },
};
